module.exports = __webpack_public_path__ + "img/weather48.fc79379a.png";